<template name="singlePage-default">
  <header-index />
  this is default single page
  <footer-index />
</template>

<script setup lang="ts" name="SinglePageDefault">
  import type { SinglePage } from '~/types';

  const props = defineProps<{
    singlePage: SinglePage
  }>()

  import headerIndex from '../../components/header/header-index.vue'
  import footerIndex from '../../components/footer/footer-index.vue'
</script>

<style scoped lang='scss'></style>
